
import styles from './index.module.scss';
import { Steps, Input, Button, message } from 'antd';
import { useEffect, useState, useContext, useMemo } from 'react';
import Iconfont from '@utils/Iconfont';
import { AppContext } from '@utils/AppContext';
import API from '@api/api';
import eventBus from '@utils/eventBus';
import { useNavigate } from "react-router-dom";


const RedemptioncodePage = () => {
    const { globalOrgInfo } = useContext(AppContext);
    const navigate = useNavigate();
    const [current, setCurrent] = useState(0)
    const [status, setStatus] = useState('default')
    const [errMsg, setErrMsg] = useState()
    const [selectedId, setSelectedId] = useState()
    const [searchText, setSearchText] = useState('');
    const [serialKey, setSerialKey] = useState('');
    const [serialKeyLength, setSerialKeyLength] = useState(0);

    const stepChange = value => {
        console.log('onChange:', value)
        if (value < current) {
            setCurrent(value)
        }
    }

    const salesVerifySerialKey = () => {
        if (!serialKey) return message.error('请输入兑换码');
        API.salesVerifySerialKey({
            serialKey: serialKey
        }).then((res) => {
            if (res.code == 0) {
                setCurrent(1)
                setErrMsg()
            } else {
                setStatus('error')
                setErrMsg(res.message)
                message.error(res.message)
            }
        })
    }

    const salesExchangePlan = () => {
        if (!selectedId) return message.error('请选择企业');
        API.salesExchangePlan({
            orgId: selectedId,
            serialKey: serialKey
        }).then((res) => {
            if (res.code == 0) {
                if (globalOrgInfo?.current.id === selectedId) {
                    message.success('会员兑换成功')
                    navigate('/')
                } else {
                    message.success('会员兑换成功，即将跳转团队账号', 1000)
                    setTimeout(() => {
                        API.postChangeOrg({
                            orgId: selectedId
                        }).then((res) => {
                            if (res.code == 0) {
                                navigate('/')
                                window.location.reload()
                            }
                        })
                    }, 1500)
                }
            } else {
                setStatus('error')
                message.error(res.message)
            }
        })
    }

    const onChange = text => {
        // 将17位序列号格式化为 4-4-4-5 的格式，例如 VQI4-VB4E-OY9E-XV0GA
        let formattedText = '';
        if (text) {
            formattedText =
                text.substring(0, 4) + '-' +
                text.substring(4, 8) + '-' +
                text.substring(8, 12) + '-' +
                text.substring(12, 17);
        }
        console.log('setSerialKey:', formattedText);
        setSerialKey(formattedText);
    }

    const onInput = value => {
        setSerialKeyLength(value.length)
    }


    const list = useMemo(() => {
        return globalOrgInfo?.orgList?.filter(item => {
            if (searchText) {
                return item.orgName && item.orgName.toLowerCase().includes(searchText.toLowerCase());
            }
            return true;
        });
    }, [globalOrgInfo, searchText]);

    const getNewOrgId = (id) => {
        console.log('getNewOrgId', id)
        setSelectedId(id)
    }

    return (
        <div className={styles.RedemptioncodePage}>
            <div className={styles.RedemptioncodeWrap}>
                <p className={styles.title}>PSAI会员兑换</p>
                <Steps
                    style={{ width: '400px', margin: '0 auto' }}
                    current={current}
                    onChange={stepChange}
                    items={[
                        { title: '输入兑换码' },
                        { title: '选择企业' }
                    ]}
                />
                {
                    current === 0 ? <>
                        <div className={styles.otpInput}>
                            <Input.OTP
                                status={status}
                                length={17}
                                separator={i => {
                                    if (i === 3 || i === 7 || i === 11) {
                                        return <span style={{ margin: '0 4px', color: '#000' }}>—</span>;
                                    }
                                    return null;
                                }}
                                onChange={onChange}
                                onInput={onInput}
                            />
                        </div>
                        {/* {errMsg && <p style={{ color: '#FF3B30', marginTop: '24px', textAlign: 'center', fontSize: 14 }}>{errMsg}</p>} */}
                        <Button disabled={serialKeyLength !== 17} type="primary" onClick={salesVerifySerialKey} className={styles.nextButton}>下一步</Button>
                        <ul>
                            <li>兑换须知</li>
                            <li>一个激活码仅能兑换一次，请谨慎兑换</li>
                            <li>激活码需在虹软官方网站输入兑换，逾期未使用将自动失效，不予补发；一般有效期为1年，具体以激活码发放的时间为准</li>
                            <li>激活码一经输入并完成产品激活，即刻绑定账号，不支持退换、转让或折现；</li>
                            <li>若遇激活码无法使用、兑换异常等问题，需在激活码有效期内联系官方客服，提供相关凭证核实处理；</li>
                            <li>虹软公司保留对激活码兑换规则的最终解释权</li>
                        </ul>
                    </> : <>
                        <div className={styles.searchWrap}>
                            <Button
                                onClick={() => eventBus.emit('OPEN_CREATE_TEAM', { isJump: false, callback: getNewOrgId })}
                                className={styles.createButton} type="primary"><Iconfont icon="icon-general_dd" /> 新建企业</Button>
                            <Input
                                placeholder="请输入企业名称"
                                size="large"
                                value={searchText}
                                onChange={e => setSearchText(e.target.value)}
                                className={styles.searchInput}
                                prefix={<Iconfont className={styles.Icon} type="icon-SearchOutlined" />} />
                        </div>
                        <div className={styles.listBox}>
                            <div className={`${styles.listWrap} _beauty_scrollbar`}>
                                {
                                    list?.filter(item => item.id).map(item => (
                                        <div
                                            onClick={() => setSelectedId(item.id)}
                                            className={selectedId === item.id ? `${styles.selectTeamItem} ${styles.active}` : styles.selectTeamItem}
                                            key={item.id}>
                                            <span>{item.orgName?.slice(0, 1)}</span>
                                            <p>
                                                <p>企业账号</p>
                                                <p>{item.orgName}</p>
                                            </p>
                                            {!item.status ? <span>未激活</span> : <span style={{ background: 'none' }}></span>}
                                            <Iconfont className={styles.selectIcon} type="icon-general_correct" />
                                        </div>
                                    ))
                                }
                                {
                                    list?.length <= 1 && <div className={styles.emptyState}>
                                        <div className={styles.emptyIcon}></div>
                                        <p>没有找到企业，请重新输入或点击新建企业创建新企业</p>
                                    </div>
                                }
                            </div>
                        </div>
                        <Button type="primary" onClick={salesExchangePlan} className={styles.nextButton}>兑换</Button>
                    </>
                }
            </div>

        </div>
    )
}
export default RedemptioncodePage;